/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Student
 */
export interface Student {
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    researchNotes: string;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    email: string;
}

/**
 * Check if a given object implements the Student interface.
 */
export function instanceOfStudent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "researchNotes" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function StudentFromJSON(json: any): Student {
    return StudentFromJSONTyped(json, false);
}

export function StudentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Student {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'role': json['role'],
        'researchNotes': json['researchNotes'],
        'email': json['email'],
    };
}

export function StudentToJSON(value?: Student | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'role': value.role,
        'researchNotes': value.researchNotes,
        'email': value.email,
    };
}

